export class AdministrarFuncionarioDTO {

    public tipoVinculacion: string;
    public estado: string;
    public tipoDocumento: string;
    public numDocumento: string;
    public primerNombre: string;
    public segundoNombre: string;
    public primerApellido: string;
    public segundoApellido: string;
    public nombreCompleto: string;
    public fechaNacimiento?: Date;
    public observaciones?: string;
    public direccion: string;
    public telefono: string;
    public extension: string;
    public correoPersonal: string;
    public nomContactoEmergencia: string;
    public numContactoEmergencia: string;
    public rH: string;
    public ePS: string;
    public pension: string;
    public numContrato: string;
    public documentoARL: Blob;
    public fechaInicioVinculacion: Date;
    public fechaFinVinculacion: Date;
    public cargo: string;
    public dependencia: number;
    public nombreDependencia: string;
    public instalacion: string;
    public progreso: number;
    public nombres: string;
    public apellidos: string;

    public listadoVehiculos: VehiculoFuncionario[];
    public correoMen: string;
    public autorizacionBicicleta: string;
    public registraHuella: boolean;
    public tarjetaIngreso: string;
    public urlFotoFuncionario: string;
    public urlFoto: string;
    public jefeArea: string;
    public rolUsuario: string;
    constructor() {}
}

export class VehiculoFuncionario {

    public idVehiculo: number;
    public tipoIdFuncionario: string;
    public numeroIdFuncionario: string;
    public placa: string;
    public estado: string;
    public tipoVehiculo: string;
    public fechaRegistro: Date;
    public fechaModificacion: Date;
    public usuarioModificacion: string;
    public ordenVehiculo: string;
    public otro: string;

    constructor() {}
}
